const Button = (props) => {
    return (
        <div>
            <button className="btn bg-blue border-none text-white hover:bg-gray hover:text-black">{props.text}</button>
        </div>
    );
};

export default Button;
